import { patientColumns } from './patientColumns';
import { insuranceColumns } from './insuranceColumns';
import { appointmentColumns } from './appointmentColumns';

export const columnHeaderBaseOptions = [
  { label: null, value: null },
  ...patientColumns,
  ...insuranceColumns,
  ...appointmentColumns
];
